import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../ApiEndPoints';

// Async thunk for fetching latest enrolled courses
export const getLatestEnrolledCoursesAPI = createAsyncThunk(
  'dashboardCards/getLatestEnrolledCourses',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState();
      const token = state.auth.token || localStorage.getItem('token');
      
      if (!token) {
        return rejectWithValue('No authentication token found');
      }

      const response = await fetch(`${BASE_URL}student/latest-enrolled-courses`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || 'Failed to fetch latest enrolled courses');
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message || 'Network error occurred');
    }
  }
);

const dashboardCardsSlice = createSlice({
  name: 'dashboardCards',
  initialState: {
    courses: [],
    isLoading: false,
    isError: false,
    message: null
  },
  reducers: {
    clearDashboardCardsError: (state) => {
      state.isError = false;
      state.message = null;
    },
    clearDashboardCardsMessage: (state) => {
      state.message = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLatestEnrolledCoursesAPI.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.message = null;
      })
      .addCase(getLatestEnrolledCoursesAPI.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.courses = action.payload.data || [];
        state.message = action.payload.message;
      })
      .addCase(getLatestEnrolledCoursesAPI.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.courses = [];
      });
  }
});

export const { clearDashboardCardsError, clearDashboardCardsMessage } = dashboardCardsSlice.actions;
export default dashboardCardsSlice.reducer;
